/* eslint-disable no-unused-vars */
import { Iconic } from '@/commons/iconic';
import {
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  TableSelectedAction,
  TableSkeleton,
} from '@/commons/table';
import { Box, IconButton, Table, TableBody, TableContainer, Tooltip } from '@mui/material';
import { translates } from '@/utils';
import GeneralTableRow from '../TableRow';
import { PropsListTable } from './types';

export const ListTable = <T extends Record<string, unknown>, K>({
  onSort,
  onSelectRow,
  setSelected,
  setPage,
  onSelectAllRows,
  onChangePage,
  onChangeRowsPerPage,
  handleOpenConfirm,
  filterName,
  tableData,
  page,
  selected,
  isLoading,
  order,
  orderBy,
  dataInPage,
  dataFiltered,
  rowsPerPage,
  dense,
  dataStruct,
  navigateHandle,
  actions,
  actionParamId,
  paginator,
}: PropsListTable<T, K>) => {
  const denseHeight = dense ? 60 : 80;
  const isNotFound = (!dataFiltered.length && !!filterName) || (!isLoading && !dataFiltered.length);
  return (
    <>
      <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
        {!!onSelectAllRows && (
          <TableSelectedAction
            dense
            numSelected={selected?.length ?? 0}
            rowCount={tableData.length}
            onSelectAllRows={(checked) =>
              onSelectAllRows(
                checked,
                tableData.map((row) => String(row.id || row._id))
              )
            }
            action={
              <Tooltip title={translates.delete}>
                <IconButton color="primary" onClick={handleOpenConfirm}>
                  <Iconic icon="eva:trash-2-outline" />
                </IconButton>
              </Tooltip>
            }
          />
        )}
        <Box sx={{ overflowX: 'auto' }}>
          <Table size="small" sx={{ minWidth: 960 }}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={dataStruct}
              rowCount={tableData.length}
              numSelected={selected?.length}
              onSort={onSort}
              onSelectAllRows={
                onSelectAllRows
                  ? (checked) =>
                      onSelectAllRows(
                        checked,
                        tableData.map((row) => String(row.id || row._id))
                      )
                  : undefined
              }
            />
            <TableBody>
              {(paginator?.paginator
                ? dataFiltered
                : (isLoading ? [...Array(rowsPerPage)] : dataFiltered).slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
              ).map((row, index) =>
                row ? (
                  <GeneralTableRow
                    key={row.id || row._id}
                    row={row}
                    selected={selected?.includes(row.id || row._id)}
                    onSelectRow={onSelectRow ? () => onSelectRow?.(row.id || row._id) : undefined}
                    actions={actions}
                    params={dataStruct}
                    actionParamId={actionParamId}
                  />
                ) : (
                  !isNotFound && <TableSkeleton key={index} sx={{ height: denseHeight }} />
                )
              )}

              {/* <TableEmptyRows
								height={denseHeight}
								emptyRows={emptyRows(page, rowsPerPage, tableData.length)}
							/> */}

              <TableNoData isNotFound={isNotFound} />
            </TableBody>
          </Table>
        </Box>
      </TableContainer>

      <TablePaginationCustom
        count={paginator?.paginator?.limit || dataFiltered.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </>
  );
};
